const port={
    state:{
        port:[]
    },
    mutations:{
        SET_PORT(state,portInfo){
            state.port=portInfo
        }
    }
}

export default port



// WEBPACK FOOTER //
// ./src/store/modules/port.js